import Swiper, { Pagination, Autoplay, FreeMode,Navigation,Thumbs } from 'swiper';


class Productshowcase {
  static init() {
    
    var swiper = new Swiper(".product-showcase-pagination-swiper", {
        modules: [Pagination, Autoplay],
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        direction: "vertical",
        breakpoints: {
            // when window width is >= 320px
            320: {
                direction: "horizontal",
                slidesPerView: 3,
            },
            // when window width is >= 640px
            1200: {
                direction: "vertical",
            },
          },
      });
      var swiper2 = new Swiper(".product-showcase-swiper", {
        modules: [Pagination, Autoplay, Thumbs],
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: swiper,
          autoScrollOffset: 1,
        },
      });

  }

}

export { Productshowcase };